import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template", "removeBtn"]
  static values = {minRows: {type: Number, default: 0}}

  connect() {
    this.counter = 0
    this.#updateButtons()
  }

  addRow() {
    const html = this.templateTarget.innerHTML.replaceAll("__IDX__", `new-${this.counter++}`)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    this.#updateButtons()
  }

  removeRow(e) {
    const btn = e.currentTarget
    const row = btn.closest("[data-nested-fields-row]")
    if (!row) return

    if (btn.dataset.new === "true") {
      row.remove()
    } else {
      const del = row.querySelector('input[name*="_delete"]')
      if (del) del.checked = true
      row.classList.add("hidden")
    }

    this.#updateButtons()
  }

  #updateButtons() {
    if (!this.hasRemoveBtnTarget) return

    const visible = this.rowsTarget.querySelectorAll("[data-nested-fields-row]:not(.hidden)")
    const disable = visible.length <= this.minRowsValue
    this.removeBtnTargets.forEach((btn) => (btn.disabled = disable))
  }
}
